import ScrollView from "devextreme-react/scroll-view";
import { PresenceHeader } from "./components/PresenceHeader";
import { ViewOutlet } from "./components/ViewOutlet";
import { ViewSwitchProvider } from "./contexts/ViewSwitchContext";

export default function PresencePage() {
  return (
    <ViewSwitchProvider>
      <ScrollView useNative>
        <div className="p-6">
          <PresenceHeader />
          <ViewOutlet />
        </div>
      </ScrollView>
    </ViewSwitchProvider>
  );
}
